<mat-form-field appearance="fill">
  <mat-label translate>Choose a Date</mat-label>
  <input matInput [min]="minDate" [max]="maxDate" [matDatepicker]="picker" (dateChange)="onDateChange($event)"
    [value]="selectedDate">
  <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
  <mat-datepicker #picker></mat-datepicker>
</mat-form-field>